/* eslint-disable camelcase */
import isFeaturedJustDroppedUrlLocationUtil from 'utils/location/is-featured-just-dropped-url'
import isJustDroppedUrlLocationUtil from 'utils/location/is-just-dropped-url'

export default function isJustDroppedCollectionProductSelect () {
  return (
    isFeaturedJustDroppedUrlLocationUtil() ||
    isJustDroppedUrlLocationUtil()
  )
}
